// @flow

import React from "react";
import { localize } from "redux-i18n";
import { ChartJS } from "@components";
import type { AbsenceRateReportData } from "@modules/reporting/reducer/trends/absence-rate/types";

type OwnProps = $Exact<{
  reportData: AbsenceRateReportData,
  weeklyPeriod: boolean,
  reportDetails: Object,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export const TrendAbsenceRateChart = ({ reportData, t, reportDetails }: Props) => {
  const trendType = ((reportDetails || {}).filters || {}).trendType || "";

  return (
    <ChartJS
      type="bar"
      className="flex-1 gs-container"
      title={t("TRENDS_ABSENCE_RATE_HEADLINES_LABEL", {
        type: t(trendType),
      })}
      data={{
        labels: ((reportData.headlines || {}).periods || []).map(
          item => item.description || item.key,
        ),
        datasets: [
          {
            label: t(trendType),
            data: ((reportData.headlines || {}).periods || []).map(item => item.value),
          },
        ],
      }}
      options={{ height: 200, wrapXAxisLabels: true }}
    />
  );
};

export default localize()(TrendAbsenceRateChart);
